import { ILocation } from './calculateDistance';

export default async (
  mapCenter: ILocation,
  consultantAddress: ILocation,
): Promise<number> => {
  const haversineDistance = (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ): number => {
    const toRad = (value: number) => (value * Math.PI) / 180;
    const R = 6371; // Earth radius in km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  };

  try {
    // Ensure both addresses have valid latitude and longitude
    if (
      !mapCenter ||
      !consultantAddress ||
      !mapCenter.lat ||
      !mapCenter.lng ||
      !consultantAddress.lat ||
      !consultantAddress.lng
    ) {
      return -1; // Return -1 to indicate failure if either geocode is missing
    }

    // Calculate distance if both addresses were geocoded
    return haversineDistance(
      mapCenter.lat,
      mapCenter.lng,
      consultantAddress.lat,
      consultantAddress.lng,
    );
  } catch (error) {
    return NaN; // Return NaN in case of any other errors
  }
};
